export default __webpack_public_path__ + "static/media/PuffedCheese.8e0cbd26.png";